import { IWishlistResort } from '@contexts/WishlistContext'
import { serverUrl } from '@utils/MkEnv'
import {API} from "@constants";

export interface WishlistResponse {
  resorts: IWishlistResort[]
}

/**
 * Fetch user's wishlist from the API
 * @param headers - Authentication headers including X-JWT-TOKEN, access-code, x-brandid, X-USERID, X-JWT-MEMBER-TOKEN
 * @returns Promise with wishlist data
 */
export const fetchWishlist = async (authHeaders: Record<string, string>): Promise<WishlistResponse> => {
  try {
    const response = await fetch(`${serverUrl}${API}/wishlist`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...authHeaders,
      },
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error('Failed to fetch wishlist:', error)
    throw error
  }
}

/**
 * Add a resort to the user's wishlist
 * @param productId - The product ID to add
 * @param headers - Authentication headers
 * @returns Promise with success status
 */
export const addToWishlist = async (productId: string, authHeaders: Record<string, string>): Promise<boolean> => {
  try {
    const response = await fetch(`${serverUrl}${API}/wishlist?resortId=${productId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...authHeaders,
      },
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const result = await response.json()
    return result === true
  } catch (error) {
    console.error('Failed to add to wishlist:', error)
    return false
  }
}

/**
 * Remove a resort from the user's wishlist
 * @param productId - The product ID to remove
 * @param headers - Authentication headers
 * @returns Promise with success status
 */
export const removeFromWishlist = async (productId: string, authHeaders: Record<string, string>): Promise<boolean> => {
  try {
    const response = await fetch(`${serverUrl}${API}/wishlist?resortId=${productId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        ...authHeaders,
      },
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const result = await response.json()
    return result === true
  } catch (error) {
    console.error('Failed to remove from wishlist:', error)
    return false
  }
}
